<template>
    <div>

        <div class="title" >员工详情</div>

        <el-card class="box-card">
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-button type="primary"  @click="edit">编辑</el-button>
                </el-col>
            </el-row>
            <display label="姓名" :value="data['name']"></display>
            <el-divider></el-divider>

            <display label="身份证号" :value="data['idno']"></display>
            <el-divider></el-divider>

            <display label="省" :value="data['province']"></display>
            <el-divider></el-divider>

            <display label="市" :value="data['city']"></display>
            <el-divider></el-divider>

            <display label="描述" :value="data['desc']"></display>
            <el-divider></el-divider>

            <display label="电话" :value="data['phone']"></display>
            <el-divider></el-divider>

            <display label="创建时间" :value="data['create_time']" isTime="true"></display>
            <el-divider></el-divider>
            <display label="更新时间" :value="data['update_time'] " isTime="true"></display>
        </el-card>

        <Input :labels="message" @confirm="Todo" @cancel="Cancel" v-if="isTodo"></Input>
    </div>
</template>

<script>
    import display from  "../display"
    import Input from "../input"
    export default {
        name: "staff_detail",
        created () {
            this.id = this.$route.params.id
            this.fetchData();
        },
        components:{
            display,
            Input
        },
        data(){
            return{
                id:"",
                loading:false,
                data:"",
                isTodo:false,
                message:[
                    {
                        key: "desc",
                        name: "描述",
                        type: "normal"
                    }
                ]
            }
        }, methods:{
            //详情
            async fetchData () {
                this.loading = true
                const {data: res} = await this.$http.post('',
                    {
                        "oper": "get_by_id",
                        "ent": "staff",
                        "info": {
                            "id": this.id
                        }
                    }
                )

                console.log(res)
                if(res.code !=0){
                    this.$message({
                        message:res.msg,
                        duration:6000
                    });;
                }
                for(let i of this.message){
                    i["value"]=res.data[i["key"]]
                }
                this.data=res.data;
                this.loading=false;
            },

            edit() {
                this.isTodo=true;
            },
            async Todo(val){
                val["id"]=this.id;
                const { data: res } = await this.$http.post('',
                    {
                        "oper": "edit",
                        "ent": "staff",
                        "info": val
                    }
                )
                console.log(res)
                if(res.code==0){
                    this.$message("操作成功");
                    this.fetchData();
                    this.isTodo=false;
                }
                else{
                    this.$message({
                        message:res.msg,
                        duration:6000
                    });;
                }
            },
            Cancel(){
                this.isTodo=false;
            },
        }
    }
</script>

<style scoped>
    .title{
        font-size: 25px;
    }

    .box-card {
        width: 900px;
        margin-top:30px;
    }
</style>
